<template>
  <div class="page-cadastrar">
    <object :data="combinedUrl" class="woli-hub">
      <iframe :src="combinedUrl" class="woli-hub"></iframe>
    </object>
  </div>
</template>

<script>
export default {
  name: 'page-cadastrar',
  data () {
    return {
      combinedUrl: this.$config.urls.cadastrar_url + `&url=${window.location.href}`
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (window.addEventListener) {
        window.addEventListener('message', this.listenMessage, false)
      } else {
        window.attachEvent('onmessage', this.listenMessage)
      }
    })
  },
  methods: {
    listenMessage (event) {
      if (event.data === 'login-successful') {
        window.parent.location.href = this.$config.urls.cadastrar_url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-cadastrar {
  padding: 0;
  position: relative;
  height: calc(100vh - 72px);
  .woli-hub {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border: none;
  }
}
</style>
